export default __webpack_public_path__ + "static/media/Epic_Transition.ccb01c38.webm";